import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { GroupContainer } from "../../../../common/components";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type MusicalWorkViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const MusicalWorkView: React.FC<MusicalWorkViewProps> = ({
  snapshotData,
}) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("MusicalWork");
  const renderExtension = useSnapshotExtension("MusicalWork");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <GroupContainer
        id="workInfo"
        title={langStore.groupMusicalWorkWorkInfoLabel}
      >
        <FormControl fullWidth>
          <ShowMultiLine
            label={langStore.MusicalWorkTitleLabel}
            value={String(snapshotData?.title ?? "")}
          />
        </FormControl>
      </GroupContainer>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
